import { useCallback } from 'react';
import { SWRConfiguration } from 'swr';

import { useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export interface Office {
  fOfficeId: number;
  fOfficeCity: string;
  fOfficeName: string;
}

export const getCompanyOffices = (): Promise<Office[]> => {
  return fetchFromOldApi('/json/office?includeInactive=true').then((r) =>
    r.json(),
  );
};

export const useGetCompanyOffices = (swrConfig?: SWRConfiguration) => {
  const { data, ...rest } = useArraySWR<Office>(
    ['companyOffices'],
    () => getCompanyOffices(),
    swrConfig,
  );

  const getOfficeById = useCallback(
    (officeId?: number): Office | undefined => {
      return !!officeId
        ? data.find((office) => office.fOfficeId === officeId)
        : undefined;
    },
    [data],
  );

  return {
    data,
    ...rest,
    getOfficeById,
  };
};
